import request from '@/utils/request';

// 获取经销商-用户协议
export function getAgreementApi(data) {
  return request({
    url: `/cloud-common-service/protocol/types-detail`,
    method: 'post',
    data,
  });
}

// 获取国家列表
export function getCountryListApi() {
  return request({
    // url: '/base-admin-app/location/v2/getCountry?type=2',
    url: '/base-admin-app/location/countryLanguageList',
    method: 'get',
  });
}

// 上传图片
export function uploadListApi(data) {
  return request({
    url: `/autel-cloud-dealer-app/v1/attachment/upload`,
    method: 'post',
    data,
  });
}

// 申请经销商
export function applyApi(data) {
  return request({
    url: `/autel-cloud-dealer-app/autonomyDealerAudit/apply`,
    method: 'post',
    data,
  });
}